import { APIDecoratorWithBaseURI } from '../../Service/api'
import { SpotifyEventPayload, SpotifyEventResponse, SpotifyArtistSearchResponse } from '../../types/spotify'

export const useSpotify = () => {
  const getSpotifyEvent = async (eventId: string): Promise<SpotifyEventResponse | boolean> => {
    try {
      const response = await APIDecoratorWithBaseURI(process.env.REACT_APP_SPOTIFY_SERVICE_URL).get(`spotify_events/${eventId}`)

      return response.data as SpotifyEventResponse
    } catch (error) {
      console.log(error)
      return false;
    }
  }

  const createSpotifyEvent = async (payload: SpotifyEventPayload): Promise<SpotifyEventResponse> => {
    try {
      const response = await APIDecoratorWithBaseURI(process.env.REACT_APP_SPOTIFY_SERVICE_URL).post('spotify_events', payload)

      return response.data.data as SpotifyEventResponse
    } catch (error) {
      console.log(error)
      throw error
    }
  }

  const getArtists = async (name: string): Promise<SpotifyArtistSearchResponse> => {
    try {
      const response = await APIDecoratorWithBaseURI(process.env.REACT_APP_SPOTIFY_SERVICE_URL).post('artists', { name })

      return response.data as SpotifyArtistSearchResponse
    } catch (error) {
      console.log(error)
      throw error
    }
  }

  return {
    getSpotifyEvent,
    createSpotifyEvent,
    getArtists
  }
}